jQuery(document).ready(function($) {

  /*
  jQuery throttle / debounce - v1.1 - 3/7/2010 -- Rewritten to accommodate webpack compilation
  http://benalman.com/projects/jquery-throttle-debounce-plugin/
  */
  function st_throttle(e,f,j,i){var c=undefined;var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g}

  /*
  $(window).on('scroll', st_throttle(500, function() {
    console.log('do something');
  }));
  */


  /* HEADER ON SCROLL ------------------------------------------- */
  $(window).on('scroll', st_throttle(250, function() {

    var window_scroll_top = $(window).scrollTop();

    if (window_scroll_top > 50) {
      $('body').addClass('scrolled-header');
    } else {
      $('body').removeClass('scrolled-header');
    }

  }));  

  // On page load, check for position of scrolltop and set header class if needed
  if ($(window).scrollTop() > 150) {
    $('body').addClass('scrolled-header');
  } else {
    $('body').removeClass('scrolled-header');
  }

  /* MODAAL FUNCTIONALITY --------------------------------------- */

  // For text/image columns with a video button
  $('a.modaal-video').modaal({
    type: 'video'
  });

  // For team member information modals
  $('.team-member > a.wrap').modaal({
    'background': '#1b3962',
    'overlay_opacity': 0.75,
    'custom_class': 'team-member-modal',
    'hide_close': true
  });
  $('.team-member-modal-content button.close-modal').on('click', function() {
    $('.team-member > a.wrap').modaal('close');
  });


  /* NAVIGATION ------------------------------------------------- */
  $('#navigation').each(function() {

    // Create variable for container element
    var $navigation = $(this);

    // Handle no-link menu items
    $('> ul.menu', $navigation).each(function() {

      // Create variable for the main navigation menu
      var $menu = $(this);

      // Handle items with no-link
      $('li.no-link', $menu).each(function() {

        // Create variable to contain the text of the item
        var element_text = $('> a', this).text();

        $('> a', this).detach();
        $(this).removeClass('no-link').prepend('<span class="no-link">'+element_text+'</span>');

      });

    });

    // Configure the mobile menu
    var mmenu = new Mmenu( '#navigation', {
      'offCanvas': {
        'position': 'right-front'
      },
      'navbar': false,
      'navbars': [
        {
          'use': true,
          'position': 'top',
          'content': [
            'prev',
            'title',
            'close'
          ]
        }
      ]
    },{
      'offCanvas': {
        'clone': true
      }
    });

    // Customize the mmmenu content
    $('#mm-clone-navigation').each(function() {
      
      // Declare variable for mmenu
      var $mmenu = $(this);

      // Append items to the first panel
      $('.mm-panels .mm-panel:first-child', $mmenu).each(function() {

        // Dupe the header supplementary menu
        var $supplementary_header = $('#menu-supplementary-header').clone();
        $supplementary_header.attr({
          'id': '',
          'class': 'header-supplementary'
        });
        $('li', $supplementary_header).each(function() {
          $(this).attr({
            'id': ''
          });
        });
        $(this).append($supplementary_header);


        // Append the FDIC Disclaimer
        $(this).append($('#header .fdic-disclaimer').clone());

      });

    });

    // Utilize mmenu API to use independent mobile menu trigger
    var mmenu_api = mmenu.API;
    $('#mm-trigger').on('click', function() {
      if ($('body').hasClass('mm-wrapper--opened')) {
        mmenu_api.close();
      } else {
        mmenu_api.open();
      }
    });

  });


  /* SEARCH FORM FUNCTIONALITY ---------------------------------- */
  $('.search-form').each(function() {

    // Declare variables
    var $search_form = $(this);
    var $search_input = $('input[type="text"]', $search_form);
    var $search_submit = $('button[type="submit"]', $search_form);
    var placeholder_text = 'Enter your search term';

    // Set default placeholder appearance of input field
    if ($search_input.val() == '') {
      $search_input.val(placeholder_text);
    }
    
    // Handle focusing and blur of the field
    $search_input.on('focus', function() {

      if ($(this).val() == placeholder_text) {
        $(this).val('');
      }

    }).on('blur', function() {

      if ($(this).val() == '') {
        $(this).val(placeholder_text);
      }
      
    });

    // Handle submit, preventing it if the placeholder is still in-place
    $search_form.on('submit', function(e) {
      if ($search_input.val() == placeholder_text) {
        e.preventDefault();
      }
    });

  });


  /* HANDLE EXTERNAL LINKS -------------------------------------- */
  $('a').filter(function() {
    if (this.hostname == 'www.netteller.com' || this.hostname == 'buckeyebank.holderaccess.com' || this.hostname == 'my.buckeyebank.com') {
      return false;
    } else if (this.hostname && this.hostname !== location.hostname) {
      return true;
    } else {
      return false;
    }
}).click(function(e) {
     if(!confirm("Buckeye Community Bank has no control over information at any site hyperlinked to or from this Site. Buckeye Community Bank makes no representation concerning and is not responsible for the quality, content, nature, or reliability of any hyperlinked site and is providing this hyperlink to you only as a convenience. The inclusion of any hyperlink does not imply any endorsement, investigation, verification or monitoring by Buckeye Community Bank of any information in any hyperlinked site. In no event shall Buckeye Community Bank be responsible for your use of a hyperlinked site."))
     {
          // if user clicks 'no' then dont proceed to link.
          e.preventDefault();
     };
});


  /* SMOOTH SCROLLING ------------------------------------------- */
  $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('[href*="#modal"]').not('.mm-btn').not('.mm-blocker').click(function(t){if(location.pathname.replace(/^\//,"")==this.pathname.replace(/^\//,"")&&location.hostname==this.hostname){

    var e = $(this.hash);

    // Determine the heights of possible elements on the page to take into consideration
    var header_height = 0; 
    // header_height = $('#header').innerHeight(); // Fixed headers need to be taken into consideration

    var wpadminbar_height = ($('#wpadminbar').length > 0 ? $('#wpadminbar').innerHeight() : 0); // Height of WordPress admin bar
    var scroll_top_padding = 20; // Extra padding

    // Calculate the final offset for scrolling by removing the height of the items above (and some padding) from the total offset height
    var e_offset_top = e.offset().top - (header_height + wpadminbar_height + scroll_top_padding);

  (e=e.length?e:$("[name="+this.hash.slice(1)+"]")).length&&(t.preventDefault(),$("html, body").animate({
    scrollTop:e_offset_top
  },1e3,function(){var t=$(e);if(t.focus(),t.is(":focus"))return!1;t.attr("tabindex","-1"),t.focus()}))}});

});
